<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

// Substeps
import Step2 from './Step2.vue'
import Step3AddSamskuldari from './Step3AddSamskuldari.vue'
import Step3TakeOverLoan from './Step3TakeOverLoan.vue'
import Step4 from './Step4.vue'
import Step5 from './Step5.vue'
import Step6 from './Step6.vue'
import Step7 from './Step7.vue'
import Step8 from './Step8.vue'
import Step10 from './Step10.vue'
import PEP from '../../Shared/PEP.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()
// Expand first panel by default
const expanded = ref([0])
</script>

<template>
  <div v-if="umsokn" class="col-sm-12">
    <!-- Header -->
    <v-row>
      <v-col>
        <h2 class="forms__header">
          {{ t('umsokn_samantekt_header') }}
        </h2>
      </v-col>
    </v-row>

    <!-- Expansion panels -->
    <v-row>
      <v-col class="application__summary">
        <v-expansion-panels v-model="expanded">
          <v-expansion-panel>
            <v-expansion-panel-title>
              {{ t('umsokn_samantekt_upplysingar') }}
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <div><Step2 :disable="true" /></div>

              <!-- Conditional branch: AddSamskuldari -->
              <div v-if="umsokn?.addSamskuldari">
                <div class="m-t-100"><Step3AddSamskuldari :disable="true" /></div>
                <div class="m-t-100"><Step4 :disable="true" /></div>
              </div>

              <!-- Conditional branch: TakeOverLoan -->
              <div v-if="umsokn?.takeOverLoan">
                <div class="m-t-100"><Step3TakeOverLoan :disable="true" /></div>
              </div>

              <!-- Shared steps -->
              <div class="m-t-100"><Step5 :disable="true" /></div>
              <div class="m-t-100"><Step6 :disable="true" /></div>
              <div class="m-t-100"><Step7 :disable="true" /></div>
              <div class="m-t-100"><Step8 :disable="true" /></div>
              <div class="m-t-100"><PEP :disable="true" :showDisclamer="false" /></div>
              <div class="m-t-100"><Step10 :disable="true" /></div>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped lang="scss">
.application__summary { width: 100%; }
.m-t-100 { margin-top: 100px; }
</style>
